/** Teal accent aligned with the M3U insight mockup (line + label chips). */
export const LIVESTREAMING_M3U_LINE_COLOR = '#14b8a6';

const getLivestreamingM3uInsightOptions = categories => {
  const isDark = localStorage.getItem('appMode') === 'dark';
  const axisTextColor = isDark ? '#e8e8e8' : '#212529';
  const themeFont =
    getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim() || 'Arial, sans-serif';
  const themeFontWeight = getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight').trim() || '400';
  const inverseRgb = getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb').trim();
  const gridLine = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)';

  return {
    chart: {
      type: 'line',
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: themeFont,
    },
    colors: [LIVESTREAMING_M3U_LINE_COLOR],
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    markers: {
      size: 5,
      strokeWidth: 2,
      strokeColors: LIVESTREAMING_M3U_LINE_COLOR,
      colors: ['#ffffff'],
      hover: { size: 7 },
    },
    dataLabels: {
      enabled: true,
      formatter: val => {
        const n = Number(val);
        return Number.isFinite(n) ? String(Math.round(n)) : '';
      },
      offsetY: -10,
      style: {
        fontSize: '11px',
        fontWeight: 600,
        fontFamily: themeFont,
        colors: ['#3cd2a5'],
      },
      background: {
        enabled: true,
        foreColor: '#ffffff',
        borderRadius: 3,
        padding: 6,
        borderWidth: 0,
        opacity: 1,
        dropShadow: { enabled: false },
      },
    },
    grid: {
      borderColor: gridLine,
      strokeDashArray: 0,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
      padding: { top: 32, right: 12, bottom: 4, left: 8 },
    },
    xaxis: {
      type: 'category',
      categories,
      axisTicks: { show: true, borderType: 'solid', color: `rgba(${inverseRgb}, .25)`, height: 6 },
      axisBorder: { show: true, color: `rgba(${inverseRgb}, .25)`, height: 1 },
      labels: {
        style: { colors: axisTextColor, fontSize: '12px', fontFamily: themeFont, fontWeight: themeFontWeight },
      },
    },
    yaxis: {
      labels: {
        formatter: value => Math.round(value),
        style: { colors: axisTextColor, fontSize: '12px', fontFamily: themeFont, fontWeight: themeFontWeight },
      },
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
      y: { formatter: v => `${Math.round(Number(v) || 0)} files` },
    },
    legend: { show: false },
  };
};

export default getLivestreamingM3uInsightOptions;
